import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralActionsAdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Bold",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "single-neutral-actions-add" }),
		/* @__PURE__ */ _jsx("path", { d: "M11.229,12.241a.5.5,0,0,0-.13-.764A7.38,7.38,0,0,0,7.456,10.5,7.543,7.543,0,0,0,.271,15.857.5.5,0,0,0,.75,16.5H8.89a.5.5,0,0,0,.492-.411A7.979,7.979,0,0,1,11.229,12.241Z" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.25,
			cy: 4.75,
			r: 4.75
		}),
		/* @__PURE__ */ _jsx("path", { d: "M17.25,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.25,11Zm3.5,7.5h-2a.5.5,0,0,0-.5.5v2a1,1,0,0,1-2,0V19a.5.5,0,0,0-.5-.5h-2a1,1,0,0,1,0-2h2a.5.5,0,0,0,.5-.5V14a1,1,0,0,1,2,0v2a.5.5,0,0,0,.5.5h2a1,1,0,0,1,0,2Z" })
	]
});
export default SvgSingleNeutralActionsAdd;
